export const MINUTES_PER_DAY = 1440;
export const SLOT_DURATION_MINUTES = 60;
export const SLOT_STEP_MINUTES = 15;
// Editor "end" dropdown allows selecting up to 6h into the next day when overnight is checked.
export const VIEW_MAX_MINUTES = MINUTES_PER_DAY + 6 * 60;
// First 5 entries of WorkingHoursState.days are always Mon-Fri (see INITIAL_WORKING_HOURS_STATE).
export const WEEKDAY_COUNT = 5;
// Default length for a frame created by double-clicking a spot on the timeline.
export const DIRECT_CREATE_DEFAULT_DURATION_MINUTES = 4 * 60;
